/**
 * BrandLogo - QuickGradeMe branding component
 *
 * Displays the brand name with each word in a different color:
 * - Quick: Blue (trustworthy, professional)
 * - Grade: Emerald (growth, learning)
 * - Me: Amber (friendly, personal)
 */

import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-xl",
  xl: "text-2xl",
};

export function BrandLogo({ className, size = "md" }: BrandLogoProps) {
  return (
    <span className={cn("font-semibold", sizeClasses[size], className)}>
      <span className="text-blue-600">Quick</span>
      <span className="text-emerald-600">Grade</span>
      <span className="text-amber-500">Me</span>
    </span>
  );
}

/**
 * Inline brand name for use in text content
 */
export function BrandName() {
  return (
    <span className="font-semibold">
      <span className="text-blue-600">Quick</span>
      <span className="text-emerald-600">Grade</span>
      <span className="text-amber-500">Me</span>
    </span>
  );
}
